module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1014-dfd9d7bb23afec8462111809d0024048.png";